import {GpsFeatureMenu} from './GpsFeaturesScreen';
import {hasAlarmTab,alarmFeatureIds} from '../../../shared/device-profile.js';
import { useLive } from '../live';
import { Text } from '../copy';
import React from 'react';
import { View } from 'react-native';
import type { MapRenderer, QsmartActions } from '../domain/types';
import { featuresForTab } from '../domain/featureCatalog';
import { FeatureList, FeatureRows } from '../components/FeatureList';
import { MapSlot } from '../components/MapSlot';
import { Card, Eyebrow, Pill, Row, Screen, SectionTitle, Title, useStyles } from '../components/primitives';

export function PositionScreen({ actions, mapRenderer }: { actions: QsmartActions; mapRenderer?: MapRenderer }) {
  const {tracker,state} = useLive();
  const styles = useStyles();
  const alarms=hasAlarmTab(state.snapshot?.device);
  const features = featuresForTab('position').filter((feature) => feature.id !== 'position-live'&&(!alarms||!alarmFeatureIds.includes(feature.id)));
  return (
    <Screen testID="position-screen">
      <Title subtitle={"Se enhedens seneste position. Skift korttype, og zoom ind eller ud på kortet."}>Position</Title>
      <View style={{ gap: 12 }}>
        <MapSlot renderer={mapRenderer} label={tracker.positionAge} onRefresh={() => { void actions.refreshPosition(); }} onOpenExternal={actions.openExternalMap} />
      </View>
      <SectionTitle>{alarms?'Position':'Placering og tryghed'}</SectionTitle>
      {state.snapshot?.device?.profile?.protocol==='gt06'?<GpsFeatureMenu section="position" after={<FeatureRows features={features.filter(f=>['position-quality','position-sources'].includes(f.id))} onOpen={actions.openScreen}/>}><FeatureRows features={features.filter(f=>['position-route'].includes(f.id))} onOpen={actions.openScreen}/></GpsFeatureMenu>:<FeatureList features={features} onOpen={actions.openScreen} />}
    </Screen>
  );
}
